import { Component, Vue, Prop } from 'vue-property-decorator'
import { GetMultiplier, GetBuyMoreResponseFromCode } from '@/utils/GameUtils'
import { EventBus } from '@/utils/eventbus'
import { IBuyMoreResult } from '@/store/modules/game/interfaces'
import SmoothScroll from '@/utils/scroll'

@Component
export default class GameFooter extends Vue {

  private minPicks: number =  3
  private maxPicks: number = 10

  private pickState() {
    const cartCount = this.$store.getters.SELECTIONS_COUNT;
    if (cartCount < this.minPicks) {
      return `Pick ${3 - cartCount} more to play`
    }
    if (cartCount === this.maxPicks) {
      return `${this.maxPicks} picks for ${GetMultiplier(cartCount-1)}x!`
    }

    return `Pick 1 more for ${GetMultiplier(cartCount)}x`
  }

  private bubbleState() {
    const cartCount = this.$store.getters.SELECTIONS_COUNT
    return cartCount < 3 ? 'warn' : ''
  }

  isSubmitting = false

  private getHandler(sport: string, cb: (msg: string) => void): (idx: number, evt: MouseEvent) => void {
    return (idx: number, evt: MouseEvent) => { 
      //@ts-ignore
      evt.toElement.disabled = true
      //@ts-ignore
      evt.toElement.innerHTML = `<div class='lds-ellipsis'><div></div><div></div><div></div><div></div></div>`

      this.$store.dispatch('BUY_MORE', sport).then((res: IBuyMoreResult) => {
        this.$modal.hide('dialog')
        if (res.errorCode) {
          cb(GetBuyMoreResponseFromCode(res.errorCode, sport))
        } else {
          //need to add some loaders so the user knows whats going on + give us somewhere to scroll to
          this.$store.dispatch('INJECT_BUY_MORE_LOADERS', sport)
          setTimeout(() => {
            EventBus.$emit('preBoughtMatchups')

            //scroll the loaders / results into view
            const container = document.querySelector('.matchup-cards')
            if (container) {
              SmoothScroll({
                duration: 800, 
                element: container as HTMLElement,
                to: container.scrollHeight
              })
            }
          }, 250)
        }
      })
    }
  }

  private genBuyDialog(cb: (msg: string) => void) {
    this.$modal.show('dialog', {
      text: 'You are about to buy 4 more matchups at the cost of ¢20',
      buttons: [
        {
          title: 'Cancel'
        },
        {
          title: 'NBA',
          class: 'buy-more vue-dialog-button',
          handler: this.getHandler('znba', cb)
        },
        {
          title: 'NFL',
          class: 'buy-more vue-dialog-button',
          handler: this.getHandler('znfl', cb)
        }
     ],
    })
  }

  private genErrorDialog(msg: string) {
    this.$modal.show('dialog', {
      text: msg,
      buttons: [
        {
          title: 'Close'
        }
     ],
    })
  }

  private moreClick() {
    this.genBuyDialog((msg) => {
      this.genErrorDialog(msg)
    })
  }

  private countdown = this.$store.getters.SETTLEMENTCOUNTDOWN

  private mounted() {
    EventBus.$on('globalTick', () => {
      this.countdown = this.$store.getters.SETTLEMENTCOUNTDOWN
      this.$forceUpdate()
    })

    EventBus.$on('gameLobbyLoaded', () => {
      this.countdown = this.$store.getters.SETTLEMENTCOUNTDOWN
      this.$forceUpdate()
    })
  }

  private render(h: any): any {
    let footerBubble
    let settlementTime
    let buyMore

    if (this.$store.getters.ISCLASSIC) {
      const ct = this.countdown(Date.now())
      if (ct) {
        settlementTime = (<div class='settlement-info'>Closes in: {ct}</div>)
      } else {
        settlementTime = <div class='settlement-info'>Opening soon</div>
      }

      if (this.$store.getters.SETTLEMENTTIMELEFT(Date.now()) >= 300) {
        //buyMore = (<button onclick={this.moreClick.bind(this)} class='buy-more'>Buy More</button>)
      } else {
        //buyMore = (<button disabled class='buy-more'>Waiting</button>)
      }
    }

    if (!(this.$route.meta.group == 'account') && !(this.$route.meta.group == 'home') && !(this.$route.meta.group == 'draft')) {
      footerBubble = <div class={`bubble ${this.bubbleState()}`}>
        {this.pickState()}
        {settlementTime}
        {buyMore}
        </div>
    }

    const cartCount = this.$store.getters.SELECTIONS_COUNT;
    return (
      <div class={`footer ${footerBubble ? 'has-bubble' : 'no-bubble'}`}>
          {footerBubble}
          <router-link to='/lobby'>Daily</router-link>
          <router-link to='/virtual'>Virtual</router-link>
          <router-link to='/draft' class={`draft-icon ${this.bubbleState()}`}>
            {
              //<span>{cartCount}</span>
            }
            <svg viewBox='0 0 200 200'>
                <use xlinkHref='#draft'></use>
            </svg>
          </router-link>
          <router-link to='/account'>Account</router-link>
    </div>
    );
  }
}
